import { MessageCircle } from 'lucide-react';

export function ChatMessages({ messages, userName, messagesEndRef }) {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-3 min-h-[300px] max-h-[380px]">
      {messages.length === 0 && (
        <div className="text-center py-8">
          <MessageCircle className="w-10 h-10 text-white/10 mx-auto mb-3" />
          <p className="text-white/30 text-sm">Start a conversation with support</p>
        </div>
      )}
      {messages.map((msg, i) => (
        <div key={msg.id || i} className={`flex ${msg.sender_type === 'user' ? 'justify-end' : 'justify-start'}`}>
          {msg.sender_type === 'system' ? (
            <div className="text-center w-full py-2">
              <span className="text-white/30 text-xs bg-white/5 px-3 py-1 rounded-full">{msg.message}</span>
            </div>
          ) : (
            <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 ${
              msg.sender_type === 'user'
                ? 'bg-gradient-to-br from-cyan-500/30 to-purple-500/30 text-white'
                : 'bg-white/5 text-white/80'
            }`}>
              {msg.sender_type === 'agent' && (
                <p className="text-cyan-400 text-xs font-medium mb-1">{msg.sender_name || 'Support'}</p>
              )}
              <p className="text-sm">{msg.message}</p>
              <p className="text-white/20 text-[10px] mt-1 text-right">
                {msg.created_at ? new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
              </p>
            </div>
          )}
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
}
